var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accountAnnouncementWrap"},[_c('div',{staticClass:"accountAnnouncementTitle"},[_vm._v("Upcoming events:")]),_c('div',{staticClass:"marquee"},[_c('div',{staticClass:"marqueeRow"},_vm._l((_vm.items),function(item,index){return _c('account-announcement-item',{key:index,attrs:{"item":item}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }